import { serverTimestamp } from 'firebase/firestore';

const time = function () {
  return serverTimestamp();
};

var currentTime = time;

export { currentTime as default };
